import { jsx as _jsx } from "react/jsx-runtime";
import { mapFallbackMessage } from './googleMapsLogic.js';
import styles from './map.module.css';
/**
 * MapUnavailableNotice — the clearly-labelled banner shown whenever the
 * workforce/site map renders the dependency-free SVG fallback instead of the
 * interactive Google Maps JS layer (no client key configured, or the script
 * failed to load — e.g. a referrer-restriction mismatch). It never claims the
 * fallback IS Google Maps, and never renders placeholder tiles: the SVG
 * beneath it draws the same real markers, fences, and breadcrumb polyline the
 * interactive layer would.
 */
export function MapUnavailableNotice({ reason }) {
    return (_jsx("p", { className: styles.fallbackNotice, role: "status", children: mapFallbackMessage(reason) }));
}
//# sourceMappingURL=MapUnavailableNotice.js.map